import type { IPagination } from "../../../../types/models/pagination.models.types";
import type {
  IFixedPayout,
  ISocial,
} from "../../../../types/models/social.models.types";
import { useGetHttp } from "../../http.hook";

export interface IAddedFixedPayout {
  id: string;
  fixedPayout: IFixedPayout;
  social: ISocial;
}

interface IResponse {
  campaignFixedPayouts: Array<IAddedFixedPayout>;
  pagination: IPagination;
}

export function useGetFixedPayoutsAdminHttp() {
  return useGetHttp<IResponse>({
    path: "/admin/campaigns/:campaignId/fixed-payouts",
  });
}
